<template>
  <div class="bom-validation-toggle-similar flex">
    <div class="bom-validation-toggle-similar__toggle">
      <span class="bom-validation-toggle-similar__toggle-title">
        {{ toggleModelValue ? 'Hide common results' : 'Show common results' }}
      </span>
      <mi-switch
        v-model="toggleModelValue"
        color="primary"
        :disable="!versionToggleEnabled"
        @click="saveLastVersionPreference"
      >
      </mi-switch>
    </div>
  </div>
</template>

<script>
  import { inject, watch } from 'vue'
  import { LocalStorage } from 'quasar'
  import recordAnalytics from '@/utils/analytics/recordAnalytics'
  import { BOM_VALIDATIONS_SIMILAR_RESULTS_TOGGLE } from '@/utils/analytics/constants/validations/constants'
  import {
    BOM_VALIDATION_ERROR_TYPES_METRICS,
    SHOW_SIMILAR_RESULTS_PROVIDER,
    SHOW_NEW_VERSION_PROVIDER
  } from '@/constants'
  import MiSwitch from '../../../../../packages/@mi-library/MiSwitch/MiSwitch.vue'

  export default {
    name: 'SimilarResultsToggle',
    components: {
      MiSwitch
    },
    props: {
      resultType: {
        type: String,
        required: false,
        default: ''
      },
      validationId: {
        type: String,
        required: false,
        default: ''
      }
    },
    setup(props) {
      const toggleModelValue = inject(SHOW_SIMILAR_RESULTS_PROVIDER)
      const versionToggleEnabled = inject(SHOW_NEW_VERSION_PROVIDER)

      watch(versionToggleEnabled, newVal => {
        if (!newVal) {
          toggleModelValue.value = false
        }
      })

      const saveLastVersionPreference = () => {
        LocalStorage.set(process.env.VUE_APP_STORAGE_KEY_VALIDATIONS_SIMILAR_RESULTS, toggleModelValue.value)

        recordAnalytics({
          name: BOM_VALIDATIONS_SIMILAR_RESULTS_TOGGLE,
          attributes: {
            toggleOn: toggleModelValue.value.toString(),
            validationId: props.validationId,
            resultType: BOM_VALIDATION_ERROR_TYPES_METRICS[props.resultType]
          }
        })
      }

      return {
        toggleModelValue,
        versionToggleEnabled,
        saveLastVersionPreference
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bom-validation-toggle-similar {
    margin: 0 0 4px;
    padding: 16px 12px;
    justify-content: space-between;

    &__toggle-title {
      font-size: 14px;
      color: #244b84;
      margin-right: 8px;
    }
  }
</style>
